export default "__VITE_ASSET__DMR_nW1g__"